import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import { IProcedure } from 'interfaces/HistoricalResults/IProcedure';
import { IResultDetails } from 'interfaces/HistoricalResults/IResultDetails';
import ProcedureResultTable from './components/ProcedureResultTable/ProcedureResultTable';
import './ProcedureDetails.scss';

interface IProcedureDetailsProps {
  procedures: IProcedure[];
  resultDetails: IResultDetails;
  resultIncrement: number;
}

const ProcedureDetails = ({ procedures, resultDetails, resultIncrement }: IProcedureDetailsProps) => {
  const procedureHeader = useCallback(
    (approved, name) => {
      return approved !== 2 && resultDetails.StatCd != 3 ? (
        <Box className="procedureHeader incomplete">{name} - Incomplete | This is raw data and has not yet been reviewed</Box>
      ) : (
        <Box className="procedureHeader">{name}</Box>
      );
    },
    [resultDetails.StatCd]
  );

  const procedureResults = useCallback(
    (procedure: IProcedure) => {
      const results = [];
      for (let resultBlock = 0; resultBlock < procedure.ResultBlocks; resultBlock++) {
        results.push(
          <ProcedureResultTable
            key={resultBlock}
            procedure={procedure}
            resultDetails={resultDetails}
            resultBlock={resultBlock}
            resultIncrement={resultIncrement}
          />
        );
      }
      return results;
    },
    [resultIncrement, resultDetails]
  );

  return (
    <Box className="procedureDetails">
      {procedures?.map((m) => (
        <Box key={m.Name}>
          {procedureHeader(m.Approved, m.Name)}
          {procedureResults(m).map((results) => results)}
        </Box>
      ))}
    </Box>
  );
};

export default ProcedureDetails;
